import { RouteConfig } from 'vue-router';

import { multiGuard } from '../Middleware/MultiGuard';
import { permissionShowCourse } from '../Middleware/permission/Course';
import { permissionFeature } from '../Middleware/permission/Feature';

export const NAME_ROUTES_COURSE = {
  LIST: 'CoursesList',
  SHOW: 'Courses'
};

export const Course: Array<RouteConfig> = [
  {
    path: '/cursos',
    component: () => import('@/layouts/Default/index.vue'),
    beforeEnter: permissionShowCourse,
    children: [
      {
        path: '',
        name: NAME_ROUTES_COURSE.LIST,
        component: () => import(
          /* webpackChunkName: "course-list" */ '@/pages/Courses/pages/ListCourses/ListCourses.vue'
        ),
        meta: { title: 'Cursos' },
        beforeEnter: multiGuard([permissionFeature])
      }
    ]
  },
  {
    path: '/cursos',
    component: () => import('@/layouts/Sidebar/index.vue'),
    beforeEnter: permissionShowCourse,
    children: [
      {
        path: ':slugCourse/:idCourses/:idClass',
        name: NAME_ROUTES_COURSE.SHOW,
        component: () => import(/* webpackChunkName: "course" */ '@/pages/Courses/Courses.vue'),
        meta: { title: 'Cronograma do Curso' },
        beforeEnter: multiGuard([
          permissionFeature
          // permissionCoursePage,
        ])
      }
    ]
  }
];
